import {
  WSDataItemProps,
  WSLabelProps,
  WSTableCellProps
} from "@wingspanhq/fe-component-library";
import { mapRequirementDefinitionTemplateTierConfig } from "./config/maps";
import { getRequirementDefinitionTemplateByParams } from "./utils/getRequirementDefinitionTemplateByParams";

export { getRequirementDefinitionTemplateByParams };

// Selectors

export function getRequirementDefinitionIcon(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
) {
  const template = getRequirementDefinitionTemplateByParams(...args);
  return template.icon;
}

export function getRequirementDefinitionName(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
) {
  const template = getRequirementDefinitionTemplateByParams(...args);
  return template.name;
}

export function getRequirementDefinitionHelperText(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
) {
  const template = getRequirementDefinitionTemplateByParams(...args);
  return template.helperText;
}

export function getRequirementDefinitionTier(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
) {
  const template = getRequirementDefinitionTemplateByParams(...args);
  return template.tier;
}

export function getRequirementDefinitionIsWayfinder(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
) {
  const tier = getRequirementDefinitionTier(...args);

  return mapRequirementDefinitionTemplateTierConfig[tier].isWayfinder;
}

// Component props

export function getRequirementDefinitionTableCellProps(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
): WSTableCellProps {
  const template = getRequirementDefinitionTemplateByParams(...args);

  return {
    icon: template.icon,
    text: template.name,
    secondaryText: template.helperText
  };
}

export function getRequirementDefinitionLabelProps(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
): WSLabelProps {
  const template = getRequirementDefinitionTemplateByParams(...args);

  return {
    avatar: {
      type: "icon",
      icon: template.icon
    },
    text: template.name,
    secondaryText: template.helperText
  };
}

export function getRequirementDefinitionDataItemProps(
  ...args: Parameters<typeof getRequirementDefinitionTemplateByParams>
): WSDataItemProps {
  const template = getRequirementDefinitionTemplateByParams(...args);

  return {
    icon: template.icon,
    label: "Type",
    value: template.name,
    secondaryText: template.helperText
  };
}
